// windowHeightPlugin.js
export default {
    install(app) {
        app.config.globalProperties.$getWindowHeight = () => window.innerHeight;
    }
};
